<form [formGroup]="ivkForm">
  <div class="row">
    <app-select-box
        class="col-12"
        [form]="ivkForm"
        [modelValue]="ivkForm.value.system"
        [options]="isMyInstalledBaseFlowEnabled ? [systemDetails] : systems"
        [inputName]="'system'"
        label="{{ (isMyInstalledBaseFlowEnabled
        ? 'checkout-delivery-details.selected-equipment'
        : 'request-details.select-system') | translate }}"
        [isRequired]="true"
        [search]="true"
        [loading]="installBaseLoading"
        [readOnly]="isMyInstalledBaseFlowEnabled"
        [searchPlaceholder]="'request-details.search-box-search-system-placeholder' | translate"
        (selected)="setSystemIdValue($event)">
    </app-select-box>
  </div>
  @if (!isMyInstalledBaseFlowEnabled) {
    <div class="row">
      @if (notFoundSelected(ivkForm.value.system)) {
        <div class="checkout__field col-md-12">
          <app-textfield
              class="checkout__textfield col-12"
              [form]="ivkForm"
              [modelValue]="ivkForm.value.siemensEquipmentId"
              [cssStyles]="{wrapper: 'textfield-with-prefix textfield-siemensEquipmentId'}"
              [inputName]="'siemensEquipmentId'"
              label="{{ systemIdFieldLabel() | translate }}"
              [isRequired]="true"
              [ngClass]="{'is-invalid': ivkForm.get('siemensEquipmentId')?.errors && ivkForm.get('siemensEquipmentId')?.touched}"
              [readOnly]="!notFoundSelected(ivkForm.value.system)"
              (fieldFilled)="setOrderFormValue($event)"
              [trim]="true"
              [trimWhitespaces]="true">
          </app-textfield>
        </div>
      }
      @if (notFoundSelected(ivkForm.value.system) || notInstallBaseRelatedSelected(ivkForm.value.system)) {
        <div class="checkout__field col-md-12">
          <app-select-box
              [form]="ivkForm"
              [modelValue]="ivkForm.value.businessUnit"
              [options]="businessUnits"
              [inputName]="'businessUnit'"
              label="{{ 'request-details.select-unit' | translate }}"
              [isRequired]="notFoundSelected(ivkForm.value.system) || notInstallBaseRelatedSelected(ivkForm.value.system)"
              [search]="true"
              [searchPlaceholder]="'request-details.search-box-search-system-placeholder' | translate"
              [loading]="businessUnitLoading"
              (selected)="setCompanyValues($event)">
          </app-select-box>
        </div>
      }
      @if (!(notFoundSelected(ivkForm.value.system) || notInstallBaseRelatedSelected(ivkForm.value.system)) || notFoundSelected(ivkForm.value.businessUnit)) {
        <div class="checkout__field col-md-12">
          <app-textfield
              class="checkout__textfield col-12"
              [form]="ivkForm"
              [modelValue]="ivkForm.value.companyBusinessUnit"
              [cssStyles]="{wrapper: 'textfield-with-prefix textfield-company'}"
              [inputName]="'companyBusinessUnit'"
              label="{{ 'request-details.enter-company-name' | translate }}"
              [isRequired]="notFoundSelected(ivkForm.value.businessUnit)"
              [ngClass]="{'is-invalid': ivkForm.get('companyBusinessUnit')?.errors && ivkForm.get('companyBusinessUnit')?.touched}"
              [readOnly]="!(notFoundSelected(ivkForm.value.system) || notInstallBaseRelatedSelected(ivkForm.value.system))"
              (fieldFilled)="setOrderFormValue($event)">
          </app-textfield>
        </div>
      }
    </div>
  }
</form>
